import { useLingui } from '@lingui/react/macro';
import ErrorPage from './error-page.tsx';

/**
 * page that displays http and unknown errors
 */
export default function NotFoundPage() {
  const { t } = useLingui();

  return <ErrorPage title={t`Not Found`} errorText={t`The page could bot be found!`} />;
}
